/**
 * FEEDBACK (C1) — os textos de tela APROVADOS pelo Matheus. Nenhum texto nasce aqui sem aprovação (regra da C1:
 * "Texto necessário que não esteja aprovado: pare e me traga").
 *
 * Fontes:
 *  - a tabela 4.3 do relatório da Fase 0, aprovada em 05/10 com duas trocas (`aba_pauta` = "Pauta de feedback";
 *    o feedback fica dentro do RH, e o título da tela é "Painel de feedback");
 *  - a lista `docs/handoffs/anexos/feedback-textos-a-aprovar.md`, aprovada em 05/10 (P7, P9 e N1 com o texto dele);
 *  - "Reabrir pauta" e "Gerar de novo", literais do pedido.
 * Os textos do SISTEMA ANTIGO (perguntas, seções, "Salvar avaliação", "Respostas enviadas"…) vêm do conteúdo literal
 * (`server/lib/feedback/conteudo/2026-10-05.json`), nunca daqui.
 */

export const FB = {
  // ── tabela 4.3
  titulo_painel: 'Painel de feedback',
  titulo_rodadas: 'Rodadas de feedback',
  botao_nova_rodada: 'Nova rodada',
  aba_feedback: 'Feedback',
  aba_autoavaliacao: 'Autoavaliação',
  aba_avaliacao: 'Avaliação',
  aba_comparacao: 'Comparação',
  aba_pauta: 'Pauta de feedback',
  botao_modo_reuniao: 'Modo reunião',
  estado_rascunho: 'Rascunho',
  estado_em_andamento: 'Em andamento',
  estado_concluida: 'Concluída',
  estado_reaberta: 'Reaberta',
  card_meu_desenvolvimento: 'Meu desenvolvimento',
  vazio_meu_desenvolvimento: 'Seu plano aparece aqui depois da conversa de feedback.',
  botao_gerar_comparacao: 'Gerar comparação',
  botao_gerar_de_novo: 'Gerar de novo',
  aviso_comparacao_ia: 'Texto gerado por IA a partir das duas avaliações. Confira antes de usar na conversa.',
  botao_reabrir_pauta: 'Reabrir pauta',

  // ── Painel de feedback (P1–P12)
  filtro_rodada: 'Rodada',
  campo_nome_rodada: 'Nome da rodada',
  botao_criar_rodada: 'Criar rodada',
  botao_incluir_funcionarios: 'Incluir funcionários',
  campo_avaliador: 'Avaliador',
  botao_trocar_avaliador: 'Trocar avaliador',
  aviso_troca_avaliador: '{avaliador_novo} passa a ver o feedback de {primeiro_nome} nesta rodada. {avaliador_antigo} deixa de ver.',
  situacao_pendente: 'Pendente',
  situacao_concluida: 'Concluída',
  selo_impacto: 'Impacto da saída: {nivel}',
  eixo_desempenho: 'Desempenho',
  eixo_valores: 'Valores',
  vazio_rodada_sem_ninguem: 'Nenhum funcionário nesta rodada.',

  // ── Aba "Feedback" da ficha (F1–F14)
  vazio_sem_rodada: '{primeiro_nome} não está em nenhuma rodada de feedback.',
  botao_enviar_autoavaliacao: 'Enviar autoavaliação',
  botao_copiar_link: 'Copiar link',
  botao_cancelar_link: 'Cancelar link',
  link_pendente: 'Link enviado em {data}, válido até {data_validade}.',
  autoavaliacao_nao_respondida: 'Ainda não respondida.',
  comparacao_indisponivel: 'A comparação fica disponível quando a autoavaliação e a avaliação estiverem concluídas.',
  comparacao_falhou: 'Não foi possível gerar a comparação agora. Tente de novo em alguns minutos.',
  comparacao_versoes_anteriores: 'Versões anteriores',
  comparacao_carimbo: 'Gerada em {data} por {nome}',
  aviso_pauta_reaberta: 'Pauta reaberta: o colaborador continua vendo a última versão concluída do plano e dos compromissos.',
  botao_excluir_autoavaliacao: 'Excluir autoavaliação',
  botao_excluir_avaliacao: 'Excluir avaliação',
  botao_excluir_pauta: 'Excluir pauta',
  confirmar_excluir_autoavaliacao: 'Excluir esta autoavaliação? Essa ação não pode ser desfeita.',
  confirmar_excluir_avaliacao: 'Excluir esta avaliação? Essa ação não pode ser desfeita.',
  botao_pdf: 'Baixar PDF',
  botao_pdf_completo: 'Baixar PDF completo',
  botao_enviar_plano: 'Enviar plano ao colaborador',

  // ── Link público (L1–L3)
  link_vencido: 'Este link venceu. Peça um novo a quem enviou.',
  link_encerrado: 'Este link não está mais disponível.',
  titulo_plano_publico: 'Seu plano de desenvolvimento',

  // ── Meu desenvolvimento (M1–M2)
  titulo_plano: 'Plano de desenvolvimento',
  titulo_compromissos: 'Compromissos',

  // ── Tela de obrigado da autoavaliação (Matheus, 06/10: troca o "Obrigada por dedicar…" do antigo). O anexo literal
  //    fica intacto; `envioDaAutoavaliacao` (conteudo.ts) aplica este texto no lugar do de lá.
  obrigado_autoavaliacao: 'Agradecemos por dedicar esse tempo a descrever o seu trabalho. Isso ajuda a IGM a organizar melhor os processos internos.',

  // ── Recusa do avaliador que não abre a ficha (opção (a) do Matheus, 05/10). ⚠️ Texto NOVO, levado a ele para aprovar.
  erro_avaliador_sem_ficha: '{avaliador} não abre a ficha de {primeiro_nome} no RH. Escolha como avaliador alguém que já abra essa ficha.',

  // ── Sininho (N1)
  aviso_autoavaliacao_concluida: '{nome} concluiu a autoavaliação ({rodada}).',

  // ── LITERAIS do sistema antigo usados numa tela que não recebe o conteúdo do servidor (o Painel). Fonte:
  //    `feedback-conteudo.json` (painel.vazios[0], pauta.abertura.criar_novo.placeholder, pauta.abertura.passo_funcionario.campo).
  antigo_nenhuma_rodada: 'Nenhuma rodada encontrada ainda.',
  antigo_placeholder_rodada: 'ex: Rodada 2 - Jan/2027',
  antigo_funcionario: 'Funcionário',
} as const;

/**
 * O status de cada ação do plano, NA TELA E NOS PDFs (Matheus, 05/10: *"escreva 'Pendente', 'Em andamento', 'Concluído',
 * 'Não realizado'. O valor guardado continua o do sistema antigo."*). O antigo mostrava o valor com o `_` trocado, sem
 * acento. As chaves são os valores GUARDADOS (literais do antigo) — um lugar só: o servidor aplica em `colunasDoPlano`.
 */
export const ROTULO_STATUS_DA_ACAO: Record<string, string> = {
  pendente: 'Pendente',
  em_andamento: 'Em andamento',
  concluido: 'Concluído',
  nao_realizado: 'Não realizado',
};

/** Troca `{chave}` pelos valores (chave sem valor fica como está). */
export function preencherFb(texto: string, valores: Record<string, string | number>): string {
  return texto.replace(/\{([a-z_0-9]+)\}/gi, (m, k: string) => (k in valores ? String(valores[k]) : m));
}

export type EstadoDaPauta = 'rascunho' | 'em_andamento' | 'concluida' | 'reaberta';
export const ROTULO_ESTADO_PAUTA: Record<EstadoDaPauta, string> = {
  rascunho: FB.estado_rascunho,
  em_andamento: FB.estado_em_andamento,
  concluida: FB.estado_concluida,
  reaberta: FB.estado_reaberta,
};
